<template>
  <div>
    <div class="flex items-center gap-3 py-3 cursor-pointer border-b-2" :class="{ 'border-blue-500': active }">
      <div class="flex justify-between w-full">
        <p class="font-bold text-lg" @click="toggle">{{ title }}</p>
        <div class="flex gap-3 items-center">
          <slot name="actions"></slot>
          <i @click="toggle" :class="[{ 'text-blue-500': active, rotation: active }, 'fa fa-chevron-up']"></i>
        </div>
      </div>
    </div>

    <div v-if="active" class="my-3">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  title: String,
  startsOpen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['toggle'])
const active = ref(false)

const toggle = () => {
  active.value = !active.value
  emit('toggle', active.value)
}

onMounted(() => {
  active.value = props.startsOpen
})
</script>

<style scoped>
.rotation {
  transform: rotate(180deg);
  transition: transform 0.3s ease-out;
}
.fa {
  transition: transform 0.3s ease-out;
}
</style>
